export const mapUniqueTags = (data) => {
    return data.value.uniqueTags;
};
export const mapEducationItems = (data) => {
    return data.value.resultItems;
};
